(function () {
  var selectors = [
    '#shopify-section-home #anHero.hero .hero-slide:nth-child(3) .hero-banner.mob',
    '#shopify-section-home #anHero.hero .hero-slide:nth-child(4) .hero-banner.mob'
  ].join(',');

  function restoreThemeEditorImages() {
    document.querySelectorAll(selectors).forEach(function (banner) {
      var selectedImage = banner.style.getPropertyValue('background-image');
      if (!selectedImage) return;

      if (banner.style.getPropertyPriority('background-image') !== 'important') {
        banner.style.setProperty('background-image', selectedImage, 'important');
      }
    });
  }

  function init() {
    restoreThemeEditorImages();
    requestAnimationFrame(restoreThemeEditorImages);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  window.addEventListener('load', restoreThemeEditorImages);
  window.addEventListener('pageshow', restoreThemeEditorImages);
  document.addEventListener('shopify:section:load', init);
})();
